import { matchCollabRoomHash } from "./cloudRouting";

export const matchLegacySceneHash = (hash: string) =>
  hash.match(/^#json=([a-zA-Z0-9_-]+),([a-zA-Z0-9_-]+)$/);

export const matchExternalSceneHash = (hash: string) =>
  hash.match(/^#url=(.+)$/);

// Auth callbacks and ordinary anchors must never replace the current canvas.
// Leaving a room still needs handling even when the destination has no scene hash.
export const isRecognizedSceneNavigation = (oldURL: string, newURL: string) => {
  const oldHash = new URL(oldURL).hash;
  const newHash = new URL(newURL).hash;
  return (
    oldHash !== newHash &&
    !!(
      matchLegacySceneHash(newHash) ||
      matchExternalSceneHash(newHash) ||
      matchCollabRoomHash(newHash) ||
      matchCollabRoomHash(oldHash)
    )
  );
};
